import { useEffect, useMemo, useState } from "react";
import "./index.scss";
import { Link, useLocation } from "react-router-dom";

export const Header = () => {
  const useReactElement = (
    route: string,
    title: string,
    disabled?: Boolean,
  ) => {
    let category = "inactive";
    const path = useLocation().pathname;
    if (path === route) {
      category = "active";
    }
    if (disabled) {
      category = "disabled";
      return <li className="disabled">{title}</li>;
    }
    if (path === "/" && route.includes("/leaderboard")) category = "active";

    return (
      <Link to={route}>
        <li className={category}>{title}</li>
      </Link>
    );
  };

  // Create countdown timer in DD:HH:MM:SS format for the reveal date
  // Make it a countdown timer that updates every second
  const [timeUntilReveal, setTimeUntilReveal] = useState(
    new Date("2026-03-01").getTime() - new Date().getTime(),
  );
  useEffect(() => {
    setTimeout(() => {
      setTimeUntilReveal(
        new Date("2026-03-01").getTime() - new Date().getTime(),
      );
    }, 1000);
  }, [timeUntilReveal]);

  const formatTime = (time: number) => {
    const days = Math.floor(time / (1000 * 60 * 60 * 24));
    const hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((time % (1000 * 60)) / 1000);
    return `${days}d ${hours}h ${minutes}m ${seconds}s`;
  };

  return (
    <header className="header">
      <div className="routes">
        <ul>
          {useReactElement("/csgoroll/leaderboard", "Leaderboard")}
          {/* {useReactElement("/calculator", "XP Calculator")} */}
          <a
            target="_blank"
            href="https://www.youtube.com/@budi_cs2"
            rel="noreferrer"
          >
            <li className="inactive">Youtube</li>
          </a>
          {/* {useReactElement("/coming_soon", "🤫 REALLY SOON", true)} */}
        </ul>
      </div>
    </header>
  );
};
